import { createElement as h } from 'react';
import { LESSON_CONTROLS, controlAvailable } from './lessonControls.mjs';
import './LessonControls.css';

/** Presentational only: the owning lesson supplies canonical actions.
 * Rotation is CSS-driven and must never restart navigation or reset a lesson.
 * Keep this mounted with a stable lesson key; no orientation listeners needed.
 */
export default function LessonControls({ actions, disabled = {}, visible = true }) {
  return h('nav', {
    className: 'ndg-lesson-controls',
    'aria-label': 'Lesson controls',
    'data-visible': String(visible),
    'data-ndg-map-overlay': 'true',
  }, LESSON_CONTROLS.map(({ id, label }) => h('button', {
    key: id,
    type: 'button',
    className: 'ndg-lesson-control',
    'data-control': id,
    'aria-label': label,
    disabled: !controlAvailable(id, actions, disabled),
    onClick: () => {
      if (controlAvailable(id, actions, disabled)) actions[id]();
    },
  }, h('span', null, label))));
}
